import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const TOUR_STORAGE_KEY = 'invoice-payer-company-tour-v1'

const steps = [
  { title: 'Welcome to your Company Dashboard', body: 'Here you can view metrics, transactions, and payouts for your business.', cta: 'Next', path: '/company' },
  { title: 'Overview', body: 'The overview shows key metrics for the current period, upcoming payout, and recent transactions.', cta: 'Next', path: '/company' },
  { title: 'Transactions', body: 'Search, filter, and export your transactions. Click any row for full details.', cta: 'Go to Transactions', path: '/company/transactions' },
  { title: 'Payouts', body: 'View payout history and the current period preview. Download PDF or CSV reports for each payout.', cta: 'Go to Payouts', path: '/company/payouts' },
  { title: 'Settings', body: 'Update your company profile, view fee structure, and manage notification preferences.', cta: 'Finish', path: '/company/settings' },
]

export function useOnboardingComplete() {
  const [complete, setComplete] = useState<boolean | null>(null)
  useEffect(() => {
    try {
      setComplete(localStorage.getItem(TOUR_STORAGE_KEY) === 'true')
    } catch {
      setComplete(false)
    }
  }, [])
  return complete
}

export function setOnboardingComplete() {
  try {
    localStorage.setItem(TOUR_STORAGE_KEY, 'true')
  } catch {
    // ignore
  }
}

export default function OnboardingTour() {
  const [step, setStep] = useState(0)
  const [visible, setVisible] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    try {
      if (localStorage.getItem(TOUR_STORAGE_KEY) !== 'true') {
        setVisible(true)
      }
    } catch {
      setVisible(false)
    }
  }, [])

  const current = steps[step]
  if (!visible || !current) return null

  const handleNext = () => {
    if (step < steps.length - 1) {
      setStep((s) => s + 1)
      if (steps[step + 1].path !== current.path) {
        navigate(steps[step + 1].path)
      }
    } else {
      setOnboardingComplete()
      setVisible(false)
    }
  }

  const handleSkip = () => {
    setOnboardingComplete()
    setVisible(false)
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" role="dialog" aria-modal="true" aria-labelledby="tour-title">
      <div className="rounded-xl bg-white border border-gray-200 shadow-xl max-w-md w-full p-6">
        <h2 id="tour-title" className="text-lg font-semibold text-gray-900 mb-2">{current.title}</h2>
        <p className="text-gray-600 text-sm mb-6">{current.body}</p>
        <div className="flex justify-between items-center">
          <button type="button" onClick={handleSkip} className="text-gray-500 hover:text-gray-700 text-sm">Skip tour</button>
          <div className="flex gap-2">
            <span className="text-gray-500 text-xs self-center">{step + 1} / {steps.length}</span>
            <button type="button" onClick={handleNext} className="rounded-lg bg-blue-600 hover:bg-blue-700 px-4 py-2 text-white text-sm font-medium">{current.cta}</button>
          </div>
        </div>
      </div>
    </div>
  )
}
